import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";
import Loading from "./loading.js";
import RankDataPopUp from "./rankDataPopUp";
import RankDataPopUpUser from "./rankDataPopUpUser";

const MySwal = withReactContent(Swal2);

const SellerRank = (props) => {
  const [loading, setLoading] = useState(true);
  const [rankData, setRankData] = useState([]);
  const [rankDataCancel, setRankDataCancel] = useState([]);
  const [rankUserData, setRankUserData] = useState([]);
  const [rankDepartData, setRankDepartData] = useState([]);
  const [rankSourceData, setRankSourceData] = useState([]);
  const [rankRevenueData, setRankRevenueData] = useState([]);
  const [sources, setSources] = useState([]);
  const [departs, setDeparts] = useState([]);
  const [users, setUsers] = useState([]);
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [showRankDetails, setShowRankDetails] = useState(false);
  const [showRankDetailsSource, setShowRankDetailsSource] = useState(false);
  const [showRankDetailsDepartment, setShowRankDetailsDepartment] =
    useState(false);
  const [showRankDetailsUser, setShowRankDetailsUser] = useState(false);
  const [showRankDetailsID, setShowRankDetailsID] = useState("");
  const [showRankDetailsDepart, setShowRankDetailsDepart] = useState("");
  const [usersDB, setUsersDB] = useState([]);

  const onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
  };

  const getSources = (data) => {
    var sources = [];

    data.map((el) => {
      sources.push(el.source === null ? "nie określono" : el.source);
    });

    setSources(sources.filter(onlyUnique));
  };

  const getDeparts = (data) => {
    var sources = [];

    data.map((el) => {
      sources.push(el.department === null ? "nie określono" : el.department);
    });

    setDeparts(sources.filter(onlyUnique));
  };

  const getUsers = (data) => {
    var sources = [];

    data.map((el) => {
      sources.push(el.sellerText === null ? "nie określono" : el.sellerText);
    });

    setUsers(sources.filter(onlyUnique));
  };

  const fetchRankData = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getRankData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setRankData(data);
        fetchRankDataCancel();
      })
      .catch((error) => {});
  };

  const fetchRankDataCancel = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getRankDataCancel", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setRankDataCancel(data);
        getSources(data);
        getDeparts(data);
        getUsers(data);
        fetchRankDataUser();
      })
      .catch((error) => {});
  };

  const fetchRankDataUser = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getRankUserData2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setRankUserData(
          data.sort(function (a, b) {
            return +b.count - +a.count;
          })
        );
        fetchRankDataDepart();
      })
      .catch((error) => {});
  };

  const fetchRankDataDepart = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getRankDepartData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setRankDepartData(
          data.sort(function (a, b) {
            return +b.count - +a.count;
          })
        );
        fetchRankDataSource();
      })
      .catch((error) => {});
  };

  const fetchRankDataSource = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getRankSourceData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setRankSourceData(
          data.sort(function (a, b) {
            return +b.count - +a.count;
          })
        );
        fetchRankDataRevenue();
      })
      .catch((error) => {});
  };

  const fetchRankDataRevenue = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getRankRevenueData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setRankRevenueData(
          data.sort(function (a, b) {
            return +b.value - +a.value;
          })
        );
        fetchUsers();
      })
      .catch((error) => {});
  };

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getUsersListAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsersDB(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchRankData();
  };

  useEffect(() => {
    getData();
  }, []);

  const sumCount = (data) => {
    var sum = 0;
    data.map((el) => {
      sum = sum + +el.count;
    });

    return sum;
  };

  const sumValue = (data) => {
    var sum = 0;
    data.map((el) => {
      sum = sum + +el.value;
    });

    return sum;
  };

  const handleShowRankDataDetails = (e) => {
    e.preventDefault();

    var value = e.currentTarget.attributes.value.value;
    var id = e.currentTarget.attributes.id.value;
    console.log(id);
    setShowRankDetails(true);
    setShowRankDetailsID(id);
    setShowRankDetailsDepart(value);
  };

  const handleShowRankDataDetailsUser = (e) => {
    e.preventDefault();

    var value = e.currentTarget.attributes.value.value;
    var id = e.currentTarget.attributes.id.value;
    console.log(id);
    setShowRankDetailsUser(true);
    setShowRankDetailsID(id);
    setShowRankDetailsDepart(value);
  };

  const handleShowRankDataDetailsSource = (e) => {
    e.preventDefault();

    var value = e.currentTarget.attributes.value.value;
    var id = e.currentTarget.attributes.id.value;
    console.log(id);
    setShowRankDetailsSource(true);
    setShowRankDetailsID(id);
    setShowRankDetailsDepart(value);
  };

  const handleShowRankDataDetailsDepartment = (e) => {
    e.preventDefault();

    var value = e.currentTarget.attributes.value.value;
    var id = e.currentTarget.attributes.id.value;
    console.log(id);
    setShowRankDetailsDepartment(true);
    setShowRankDetailsID(id);
    setShowRankDetailsDepart(value);
  };

  const countAggrUser = (user) => {
    var count = 0;

    rankUserData
      .filter((ex) => +ex.month === month && +ex.year === year)
      .map((el) => {
        if (el.sellerText === user) {
          count = count + el.count;
        }
      });

    return count;
  };

  const getArrAggrUser = (company) => {
    var arr = [];

    usersDB
      .filter((el) => el.companies.includes(company))
      .map((user) => {
        var rec = { sellerText: user.name, count: countAggrUser(user.name) };
        arr.push(rec);
      });

    var rec = {
      sellerText: "nie określono",
      count: countAggrUser("nie określono"),
    };
    arr.push(rec);

    return arr.sort(function (a, b) {
      return +b.count - +a.count;
    });
  };

  const userRankCHF2 = (
    <>
      {getArrAggrUser("oCHF").length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            RANKING HANDLOWCÓW DLA ODDZIAŁU oCHF
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość umów:
              {sumCount(getArrAggrUser("oCHF"))}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Handlowiec</th>
              <th>Liczba podpisanych umów</th>
            </tr>
            {getArrAggrUser("oCHF").map((user, index) => (
              <>
                <tr
                  id={user.sellerText}
                  value={"CHF"}
                  onClick={
                    props.user.role === "admin" ||
                    props.user.role === "userplus"
                      ? handleShowRankDataDetails
                      : handleShowRankDataDetailsUser
                  }
                  style={{ cursor: "pointer" }}
                >
                  <td>{index + 1}</td>
                  <td>{user.sellerText}</td>
                  <td>{user.count}</td>
                </tr>
              </>
            ))}
          </table>
        </>
      )}
    </>
  );

  const userRankCHF = (
    <>
      {rankUserData.filter(
        (el) => el.depart === "CHF" && +el.month === month && +el.year === year
      ).length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>RANKING HANDLOWCÓW DLA DZIAŁU CHF</p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość umów:
              {sumCount(
                rankUserData.filter(
                  (el) =>
                    el.depart === "CHF" &&
                    +el.month === month &&
                    +el.year === year
                )
              )}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Handlowiec</th>
              <th>Liczba podpisanych umów</th>
            </tr>
            {rankUserData
              .filter(
                (el) =>
                  el.depart === "CHF" &&
                  +el.month === month &&
                  +el.year === year
              )
              .map((rank, index) => (
                <>
                  <tr
                    id={rank.sellerText}
                    value={"CHF"}
                    onClick={
                      props.user.role === "admin" ||
                      props.user.role === "userplus"
                        ? handleShowRankDataDetails
                        : handleShowRankDataDetailsUser
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <td>{index + 1}</td>
                    <td>{rank.sellerText}</td>
                    <td>{rank.count}</td>
                  </tr>
                </>
              ))}
          </table>
        </>
      )}
    </>
  );

  const userRankSKD2 = (
    <>
      {getArrAggrUser("oSKD").length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            RANKING HANDLOWCÓW DLA ODDZIAŁU oSKD
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość umów:
              {sumCount(getArrAggrUser("oSKD"))}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Handlowiec</th>
              <th>Liczba podpisanych umów</th>
            </tr>
            {getArrAggrUser("oSKD").map((user, index) => (
              <>
                <tr
                  id={user.sellerText}
                  value={"SKD"}
                  onClick={
                    props.user.role === "admin" ||
                    props.user.role === "userplus"
                      ? handleShowRankDataDetails
                      : handleShowRankDataDetailsUser
                  }
                  style={{ cursor: "pointer" }}
                >
                  <td>{index + 1}</td>
                  <td>{user.sellerText}</td>
                  <td>{user.count}</td>
                </tr>
              </>
            ))}
          </table>
        </>
      )}
    </>
  );

  const userRankSKD = (
    <>
      {rankUserData.filter(
        (el) => el.depart === "SKD" && +el.month === month && +el.year === year
      ).length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>RANKING HANDLOWCÓW DLA DZIAŁU SKD</p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość umów:
              {sumCount(
                rankUserData.filter(
                  (el) =>
                    el.depart === "SKD" &&
                    +el.month === month &&
                    +el.year === year
                )
              )}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Handlowiec</th>
              <th>Liczba podpisanych umów</th>
            </tr>
            {rankUserData
              .filter(
                (el) =>
                  el.depart === "SKD" &&
                  +el.month === month &&
                  +el.year === year
              )
              .map((rank, index) => (
                <>
                  <tr
                    id={rank.sellerText}
                    value={"SKD"}
                    onClick={
                      props.user.role === "admin" ||
                      props.user.role === "userplus"
                        ? handleShowRankDataDetails
                        : handleShowRankDataDetailsUser
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <td>{index + 1}</td>
                    <td>{rank.sellerText}</td>
                    <td>{rank.count}</td>
                  </tr>
                </>
              ))}
          </table>
        </>
      )}
    </>
  );

  const userRankWIBOR2 = (
    <>
      {getArrAggrUser("oWIBOR").length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            RANKING HANDLOWCÓW DLA ODDZIAŁU oWIBOR
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość umów:
              {sumCount(getArrAggrUser("oWIBOR"))}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Handlowiec</th>
              <th>Liczba podpisanych umów</th>
            </tr>
            {getArrAggrUser("oWIBOR").map((user, index) => (
              <>
                <tr
                  id={user.sellerText}
                  value={"WIBOR"}
                  onClick={
                    props.user.role === "admin" ||
                    props.user.role === "userplus"
                      ? handleShowRankDataDetails
                      : handleShowRankDataDetailsUser
                  }
                  style={{ cursor: "pointer" }}
                >
                  <td>{index + 1}</td>
                  <td>{user.sellerText}</td>
                  <td>{user.count}</td>
                </tr>
              </>
            ))}
          </table>
        </>
      )}
    </>
  );

  const userRankWIBOR = (
    <>
      {rankUserData.filter(
        (el) =>
          el.depart === "WIBOR" && +el.month === month && +el.year === year
      ).length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            RANKING HANDLOWCÓW DLA DZIAŁU WIBOR
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość umów:
              {sumCount(
                rankUserData.filter(
                  (el) =>
                    el.depart === "WIBOR" &&
                    +el.month === month &&
                    +el.year === year
                )
              )}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Handlowiec</th>
              <th>Liczba podpisanych umów</th>
            </tr>
            {rankUserData
              .filter(
                (el) =>
                  el.depart === "WIBOR" &&
                  +el.month === month &&
                  +el.year === year
              )
              .map((rank, index) => (
                <>
                  <tr
                    id={rank.sellerText}
                    value={"WIBOR"}
                    onClick={
                      props.user.role === "admin" ||
                      props.user.role === "userplus"
                        ? handleShowRankDataDetails
                        : handleShowRankDataDetailsUser
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <td>{index + 1}</td>
                    <td>{rank.sellerText}</td>
                    <td>{rank.count}</td>
                  </tr>
                </>
              ))}
          </table>
        </>
      )}
    </>
  );

  const departRank = (
    <>
      {rankDepartData.filter((el) => +el.month === month && +el.year === year)
        .length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>RANKING SPRZEDAŻY WEDŁUG DZIAŁÓW</p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość umów:
              {sumCount(
                rankDepartData.filter(
                  (el) => +el.month === month && +el.year === year
                )
              )}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Dział</th>
              <th>Liczba podpisanych umów</th>
            </tr>
            {rankDepartData
              .filter((el) => +el.month === month && +el.year === year)
              .map((rank, index) => (
                <>
                  <tr
                    id={rank.department}
                    value={rank.department}
                    onClick={
                      props.user.role === "admin" ||
                      props.user.role === "userplus"
                        ? handleShowRankDataDetailsDepartment
                        : () => {
                            console.log("no access");
                          }
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <td>{index + 1}</td>
                    <td>{rank.department}</td>
                    <td>{rank.count}</td>
                  </tr>
                </>
              ))}
          </table>
        </>
      )}
    </>
  );

  const sourceRank = (
    <>
      {rankSourceData.filter((el) => +el.month === month && +el.year === year)
        .length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>RANKING SPRZEDAŻY WEDŁUG ŹRÓDEŁ</p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość umów:
              {sumCount(
                rankSourceData.filter(
                  (el) => +el.month === month && +el.year === year
                )
              )}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Źródło</th>
              <th>Liczba podpisanych umów</th>
            </tr>
            {rankSourceData
              .filter((el) => +el.month === month && +el.year === year)
              .map((rank, index) => (
                <>
                  <tr
                    id={rank.source}
                    value={"CHF"}
                    onClick={
                      props.user.role === "admin" ||
                      props.user.role === "userplus"
                        ? handleShowRankDataDetailsSource
                        : () => {
                            console.log("no access");
                          }
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <td>{index + 1}</td>
                    <td>{rank.source}</td>
                    <td>{rank.count}</td>
                  </tr>
                </>
              ))}
          </table>
        </>
      )}
    </>
  );

  const sourceRankCHF = (
    <>
      {rankSourceData.filter(
        (el) => +el.month === month && +el.year === year && el.depart === "CHF"
      ).length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            RANKING SPRZEDAŻY WEDŁUG ŹRÓDEŁ - CHF
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość umów:
              {sumCount(
                rankSourceData.filter(
                  (el) =>
                    +el.month === month &&
                    +el.year === year &&
                    el.depart === "CHF"
                )
              )}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Źródło</th>
              <th>Liczba podpisanych umów</th>
            </tr>
            {rankSourceData
              .filter(
                (el) =>
                  +el.month === month &&
                  +el.year === year &&
                  el.depart === "CHF"
              )
              .map((rank, index) => (
                <>
                  <tr
                    id={rank.source}
                    value={"CHF"}
                    onClick={
                      props.user.role === "admin" ||
                      props.user.role === "userplus"
                        ? handleShowRankDataDetailsSource
                        : () => {
                            console.log("no access");
                          }
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <td>{index + 1}</td>
                    <td>{rank.source}</td>
                    <td>{rank.count}</td>
                  </tr>
                </>
              ))}
          </table>
        </>
      )}
    </>
  );

  const sourceRankSKD = (
    <>
      {rankSourceData.filter(
        (el) => +el.month === month && +el.year === year && el.depart === "SKD"
      ).length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            RANKING SPRZEDAŻY WEDŁUG ŹRÓDEŁ - SKD
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość umów:
              {sumCount(
                rankSourceData.filter(
                  (el) =>
                    +el.month === month &&
                    +el.year === year &&
                    el.depart === "SKD"
                )
              )}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Źródło</th>
              <th>Liczba podpisanych umów</th>
            </tr>
            {rankSourceData
              .filter(
                (el) =>
                  +el.month === month &&
                  +el.year === year &&
                  el.depart === "SKD"
              )
              .map((rank, index) => (
                <>
                  <tr
                    id={rank.source}
                    value={"SKD"}
                    onClick={
                      props.user.role === "admin" ||
                      props.user.role === "userplus"
                        ? handleShowRankDataDetailsSource
                        : () => {
                            console.log("no access");
                          }
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <td>{index + 1}</td>
                    <td>{rank.source}</td>
                    <td>{rank.count}</td>
                  </tr>
                </>
              ))}
          </table>
        </>
      )}
    </>
  );

  const sourceRankWIBOR = (
    <>
      {rankSourceData.filter(
        (el) =>
          +el.month === month && +el.year === year && el.depart === "WIBOR"
      ).length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            RANKING SPRZEDAŻY WEDŁUG ŹRÓDEŁ - WIBOR
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              ilość umów:
              {sumCount(
                rankSourceData.filter(
                  (el) =>
                    +el.month === month &&
                    +el.year === year &&
                    el.depart === "WIBOR"
                )
              )}
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Źródło</th>
              <th>Liczba podpisanych umów</th>
            </tr>
            {rankSourceData
              .filter(
                (el) =>
                  +el.month === month &&
                  +el.year === year &&
                  el.depart === "WIBOR"
              )
              .map((rank, index) => (
                <>
                  <tr
                    id={rank.source}
                    value={"WIBOR"}
                    onClick={
                      props.user.role === "admin" ||
                      props.user.role === "userplus"
                        ? handleShowRankDataDetailsSource
                        : () => {
                            console.log("no access");
                          }
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <td>{index + 1}</td>
                    <td>{rank.source}</td>
                    <td>{rank.count}</td>
                  </tr>
                </>
              ))}
          </table>
        </>
      )}
    </>
  );

  const revenueRankCHF = (
    <>
      {rankRevenueData.filter(
        (el) => +el.month === month && +el.year === year && el.depart === "CHF"
      ).length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            RANKING SPRZEDAŻY WEDŁUG POTENCJALNEGO PRZYCHODU NETTO CHF
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              wartość umów:{" "}
              {Math.round(
                sumValue(
                  rankRevenueData.filter(
                    (el) =>
                      +el.month === month &&
                      +el.year === year &&
                      el.depart === "CHF"
                  )
                ).toFixed(2)
              )}{" "}
              PLN
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Handlowiec</th>
              <th>Potencjalna wartość netto podpisanych umów</th>
            </tr>
            {rankRevenueData
              .filter(
                (el) =>
                  +el.month === month &&
                  +el.year === year &&
                  el.depart === "CHF"
              )
              .map((rank, index) => (
                <>
                  <tr
                    id={rank.sellerText}
                    value={"CHF"}
                    onClick={
                      props.user.role === "admin" ||
                      props.user.role === "userplus"
                        ? handleShowRankDataDetails
                        : handleShowRankDataDetailsUser
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <td>{index + 1}</td>
                    <td>{rank.sellerText}</td>
                    <td>{Math.round(rank.value).toFixed(2)} PLN</td>
                  </tr>
                </>
              ))}
          </table>
        </>
      )}
    </>
  );

  const revenueRankSKD = (
    <>
      {rankRevenueData.filter(
        (el) => +el.month === month && +el.year === year && el.depart === "SKD"
      ).length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            RANKING SPRZEDAŻY WEDŁUG POTENCJALNEGO PRZYCHODU NETTO SKD
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              wartość umów:{" "}
              {Math.round(
                sumValue(
                  rankRevenueData.filter(
                    (el) =>
                      +el.month === month &&
                      +el.year === year &&
                      el.depart === "SKD"
                  )
                ).toFixed(2)
              )}{" "}
              PLN
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Handlowiec</th>
              <th>Potencjalna wartość netto podpisanych umów</th>
            </tr>
            {rankRevenueData
              .filter(
                (el) =>
                  +el.month === month &&
                  +el.year === year &&
                  el.depart === "SKD"
              )
              .map((rank, index) => (
                <>
                  <tr
                    id={rank.sellerText}
                    value={"SKD"}
                    onClick={
                      props.user.role === "admin" ||
                      props.user.role === "userplus"
                        ? handleShowRankDataDetails
                        : handleShowRankDataDetailsUser
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <td>{index + 1}</td>
                    <td>{rank.sellerText}</td>
                    <td>{Math.round(rank.value).toFixed(2)} PLN</td>
                  </tr>
                </>
              ))}
          </table>
        </>
      )}
    </>
  );

  const revenueRankWIOR = (
    <>
      {rankRevenueData.filter(
        (el) =>
          +el.month === month && +el.year === year && el.depart === "WIBOR"
      ).length === 0 ? (
        ""
      ) : (
        <>
          <p style={{ textAlign: "left" }}>
            RANKING SPRZEDAŻY WEDŁUG POTENCJALNEGO PRZYCHODU NETTO WIBOR
          </p>
          <div style={{ textAlign: "left" }}>
            <span style={{ fontSize: ".8vw", textAlign: "left" }}>
              wartość umów:{" "}
              {Math.round(
                sumValue(
                  rankRevenueData.filter(
                    (el) =>
                      +el.month === month &&
                      +el.year === year &&
                      el.depart === "WIBOR"
                  )
                ).toFixed(2)
              )}{" "}
              PLN
            </span>
          </div>
          <table className="clients_table" style={{ width: "50%" }}>
            <tr>
              <th>Pozycja</th>
              <th>Handlowiec</th>
              <th>Potencjalna wartość netto podpisanych umów</th>
            </tr>
            {rankRevenueData
              .filter(
                (el) =>
                  +el.month === month &&
                  +el.year === year &&
                  el.depart === "WIBOR"
              )
              .map((rank, index) => (
                <>
                  <tr
                    id={rank.sellerText}
                    value={"WIBOR"}
                    onClick={
                      props.user.role === "admin" ||
                      props.user.role === "userplus"
                        ? handleShowRankDataDetails
                        : handleShowRankDataDetailsUser
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <td>{index + 1}</td>
                    <td>{rank.sellerText}</td>
                    <td>{Math.round(rank.value).toFixed(0)} PLN</td>
                  </tr>
                </>
              ))}
          </table>
        </>
      )}
    </>
  );

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          {showRankDetailsDepartment ? (
            <RankDataPopUp
              close={() => {
                setShowRankDetailsDepartment(false);
                getData();
              }}
              rankData={rankData
                .filter(
                  (el) =>
                    el.department === showRankDetailsDepart &&
                    el.month === month &&
                    el.year === year
                )
                .concat(
                  rankDataCancel.filter(
                    (el) =>
                      el.department === showRankDetailsDepart &&
                      new Date(el.cancelDate).getMonth() + 1 === month &&
                      new Date(el.cancelDate).getFullYear() === year
                  )
                )}
            />
          ) : showRankDetailsSource ? (
            <RankDataPopUp
              close={() => {
                setShowRankDetailsSource(false);
                getData();
              }}
              rankData={rankData
                .filter(
                  (el) =>
                    el.source === showRankDetailsID &&
                    el.department === showRankDetailsDepart &&
                    el.month === month &&
                    el.year === year
                )
                .concat(
                  rankDataCancel.filter(
                    (el) =>
                      el.sellerText === showRankDetailsID &&
                      el.department === showRankDetailsDepart &&
                      new Date(el.cancelDate).getMonth() + 1 === month &&
                      new Date(el.cancelDate).getFullYear() === year
                  )
                )}
            />
          ) : showRankDetailsUser ? (
            <RankDataPopUpUser
              close={() => {
                setShowRankDetailsUser(false);
                getData();
              }}
              rankData={rankData
                .filter(
                  (el) =>
                    el.sellerText === props.user.name &&
                    el.month === month &&
                    el.year === year
                )
                .concat(
                  rankDataCancel.filter(
                    (el) =>
                      el.sellerText === showRankDetailsID &&
                      new Date(el.cancelDate).getMonth() + 1 === month &&
                      new Date(el.cancelDate).getFullYear() === year
                  )
                )}
            />
          ) : showRankDetails ? (
            <RankDataPopUp
              close={() => {
                setShowRankDetails(false);
                getData();
              }}
              rankData={rankData
                .filter(
                  (el) =>
                    el.sellerText === showRankDetailsID &&
                    el.month === month &&
                    el.year === year
                )
                .concat(
                  rankDataCancel.filter(
                    (el) =>
                      el.sellerText === showRankDetailsID &&
                      new Date(el.cancelDate).getMonth() + 1 === month &&
                      new Date(el.cancelDate).getFullYear() === year
                  )
                )}
            />
          ) : (
            <>
              <div
                style={{
                  backgroundColor: "white",
                  top: "0",
                  paddingTop: "5vh",
                  paddingBottom: "3vh",
                  paddingLeft: "2vw",
                  paddingRight: "2vw",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "1vw",
                  }}
                >
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "green",
                      borderColor: "green",
                      width: "180px",
                    }}
                    onClick={getData}
                  >
                    ODŚWIEŻ
                  </button>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  width: "20%",
                  paddingLeft: "2vw",
                }}
              >
                <div style={{ width: "45%", textAlign: "left" }}>
                  <p
                    style={{
                      margin: "0",
                      marginBottom: "10px",
                      fontWeight: "600",
                      fontSize: ".8vw",
                      paddingLeft: "20px",
                    }}
                  >
                    miesiąc
                  </p>
                  <input
                    type="number"
                    style={{
                      width: "100%",
                      padding: "0px 10px",
                      boxSizing: "border-box",
                    }}
                    value={month}
                    onChange={(e) => setMonth(+e.target.value)}
                  />
                </div>
                <div style={{ width: "45%", textAlign: "left" }}>
                  <p
                    style={{
                      margin: "0",
                      marginBottom: "10px",
                      fontWeight: "600",
                      fontSize: ".8vw",
                      paddingLeft: "20px",
                    }}
                  >
                    rok
                  </p>
                  <input
                    type="number"
                    style={{
                      width: "100%",
                      padding: "0px 10px",
                      boxSizing: "border-box",
                    }}
                    value={year}
                    onChange={(e) => setYear(+e.target.value)}
                  />
                </div>
              </div>

              <div
                style={{
                  paddingLeft: "2vw",
                  paddingBottom: "5vh",
                }}
              >
                {rankData.filter(
                  (el) => +el.month === month && +el.year === year
                ).length === 0 ? (
                  <p style={{ textAlign: "left" }}>BRAK DANYCH RANKINGOWYCH</p>
                ) : (
                  <>
                    {props.user.companies === "oCHF" ||
                    props.user.companies === "oCHF2" ||
                    props.user.role === "admin" ||
                    props.user.role === "userplus"
                      ? userRankCHF2
                      : ""}{" "}
                    <br />
                    {props.user.companies === "oSKD" ||
                    props.user.role === "admin" ||
                    props.user.role === "userplus"
                      ? userRankSKD2
                      : ""}{" "}
                    <br />
                    {props.user.companies === "oWIBOR" ||
                    props.user.role === "admin" ||
                    props.user.role === "userplus"
                      ? userRankWIBOR2
                      : ""}{" "}
                    <br />
                    {props.user.role === "admin" ||
                    props.user.role === "userplus"
                      ? departRank
                      : ""}{" "}
                    <br />
                    {props.user.role === "admin" ||
                    props.user.role === "userplus"
                      ? sourceRankCHF
                      : ""}
                    <br />
                    {props.user.role === "admin" ||
                    props.user.role === "userplus"
                      ? sourceRankSKD
                      : ""}
                    <br />
                    {props.user.role === "admin" ||
                    props.user.role === "userplus"
                      ? sourceRankWIBOR
                      : ""}
                    <br />
                    {props.user.role === "admin" ||
                    props.user.role === "userplus"
                      ? revenueRankCHF
                      : ""}
                    <br />
                    {props.user.role === "admin" ||
                    props.user.role === "userplus"
                      ? revenueRankSKD
                      : ""}
                    <br />
                    {props.user.role === "admin" ||
                    props.user.role === "userplus"
                      ? revenueRankWIOR
                      : ""}
                  </>
                )}
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default SellerRank;
